"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _semanticUiReact = require("semantic-ui-react");
var _SvgIcon = require("../icons/SvgIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Pagination = function Pagination(_ref) {
  var pageNumber = _ref.pageNumber,
    pageSize = _ref.pageSize,
    totalCount = _ref.totalCount,
    onClickPagingButton = _ref.onClickPagingButton,
    onChangePageSize = _ref.onChangePageSize,
    pageSizeOptions = _ref.pageSizeOptions,
    className = _ref.className,
    style = _ref.style;
  var totalPages = Math.ceil(totalCount / pageSize);
  var previousPage = pageNumber > 1 ? pageNumber - 1 : 1;
  var nextPage = pageNumber < totalPages ? pageNumber + 1 : totalPages;
  var lastPage = totalPages;
  var startRow = pageNumber === 1 ? 1 : (pageNumber - 1) * pageSize + 1;
  var lastRow = startRow + pageSize - 1 > totalCount ? totalCount : startRow + pageSize - 1;
  var cssClasses = className ? "pagination-component ".concat(className) : "pagination-component";
  var defaultPageSizeOptions = [{
    text: "10 rows",
    value: 10,
    key: "10"
  }, {
    text: "50 rows",
    value: 50,
    key: "50"
  }, {
    text: "100 rows",
    value: 100,
    key: "100"
  }, {
    text: "All rows",
    value: 10000000,
    key: "10000000"
  }];
  var options = pageSizeOptions || defaultPageSizeOptions;
  if (totalPages > 1) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssClasses,
      style: style
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-range"
    }, "Showing ", startRow, " to ", lastRow, " of ", totalCount, " rows"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttons-container"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      type: "button",
      title: "First page",
      className: "pagination-button first svg-button",
      onClick: function onClick() {
        return onClickPagingButton(1);
      },
      disabled: pageNumber === 1
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "visually-hidden"
    }, "First page"), /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgChevronLeftDouble, null)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      type: "button",
      title: "Previous page",
      className: "pagination-button previous svg-button",
      disabled: pageNumber === 1,
      onClick: function onClick() {
        return onClickPagingButton(previousPage);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "visually-hidden"
    }, "Previous page"), /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgChevronLeft, null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-number"
    }, "Page ", pageNumber, " of ", totalPages), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      type: "button",
      title: "Next page",
      className: "pagination-button next svg-button",
      onClick: function onClick() {
        return onClickPagingButton(nextPage);
      },
      disabled: pageNumber === totalPages
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "visually-hidden"
    }, "Next page"), /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgChevronRight, null)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      type: "button",
      title: "Last page",
      className: "pagination-button last svg-button",
      onClick: function onClick() {
        return onClickPagingButton(lastPage);
      },
      disabled: pageNumber === totalPages
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "visually-hidden"
    }, "Last page"), /*#__PURE__*/_react["default"].createElement(_SvgIcon.SvgChevronRightDouble, null))), onChangePageSize && /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-size"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
      onChange: onChangePageSize,
      options: options,
      value: pageSize,
      fluid: true,
      selection: true,
      autoComplete: "none"
    }))));
  } else if (onChangePageSize) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: cssClasses,
      style: {
        justifyContent: "flex-end"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "page-size"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Dropdown, {
      onChange: onChangePageSize,
      options: options,
      value: pageSize,
      fluid: true,
      selection: true,
      autoComplete: "none"
    })));
  } else {
    return null;
  }
};
Pagination.propTypes = {
  pageNumber: _propTypes["default"].number.isRequired,
  pageSize: _propTypes["default"].number.isRequired,
  totalCount: _propTypes["default"].number.isRequired,
  onClickPagingButton: _propTypes["default"].func.isRequired,
  // function signature handleClickPagingButton(pageNumber)
  onChangePageSize: _propTypes["default"].func,
  pageSizeOptions: _propTypes["default"].array,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
var _default = Pagination;
exports["default"] = _default;